module.exports = __webpack_public_path__ + "img/homeLogo.61f16370.png";